export default {"src":"/_next/static/media/bnb-chain.ac0e78e2.svg","height":177,"width":1004,"blurWidth":0,"blurHeight":0};